import { ColDef } from 'ag-grid-community';

const columnDefs: ColDef[] = [
    { rowDrag: true, width: 10, maxWidth: 50, resizable: false, editable: false },
    { headerCheckboxSelection: true, checkboxSelection: true, width: 50, maxWidth: 50, resizable: false },
    {
        field: 'label',
        minWidth: 100,
        headerName: 'Column Name'
    }
];

const toolBarPanelOptions: ['search'] = ['search'];
const rowSelection: 'single' | 'multiple' = 'multiple';

export const defaultAgGridProps = {
    isLoading: false,
    rowheight: 40,
    showToolbarPanel: true,
    toolBarPanelOptions: toolBarPanelOptions,
    columnDefs: columnDefs,
    suppressContextMenu: true,
    suppressMenuHide: true,
    gridOptions: { rowDragManaged: true, rowSelection: rowSelection, suppressRowClickSelection: true, suppressDragLeaveHidesColumns: true },
    searchBarFullWidth: true
};
